import { useCallback, useState } from "react"
import { GetApp } from "../../App"
import { IShip } from "../../Types"
import { classNames } from "../../Components"
import { Icon, Icons } from "../../Components/Icon"
import { MenuCloseContext } from "../../Components/Menu"
import { MenuAccount } from "../../Components/MenuAccount"
import { MenuHelp } from "../../Components/MenuHelp"
import { MenuShip } from "../../Components/MenuShip"

interface AppHeaderViewProps {
  ship?: IShip;
  hideMenus?: boolean;
  hideShipMenu?: boolean;
}

export function AppHeaderView({ ship, hideMenus, hideShipMenu }: AppHeaderViewProps) {
  const app = GetApp()!;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMobileMenu = useCallback(() => setMobileMenuOpen(false), []);

  return (
    <div className={classNames(["ShipView-header-container", "session-type-" + app.sessionType])}>
      <div className="ShipView-header-fill pre"></div>
      <div className="ShipView-header">
        <div className="ShipView-title">
          <span className="ShipView-logo" style={{ background: `url('/icon${app.theme == "light" ? "-black" : app.theme == "night" ? "-red" : ""}.svg') center center no-repeat` }}></span>
          <span className="ShipView-title-text">LOGBOOK{app.cloudSession() ? " Cloud" : app.localSession() ? " Companion" : ""}</span>
        </div>
        <div className="ShipView-menus">
          {/* Mobile hamburger menu */}
          <div className="ShipView-menus-mobile">
            <div className="Menu">
              <button className="Menu-button" onClick={() => window.location.reload()}>
                <Icon icon={Icons.Refresh} />
              </button>
            </div>
            {!hideMenus && (
              <div className="Menu hamburger-menu-button">
                <button className="Menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                  ☰
                </button>
                {mobileMenuOpen && (
                  <>
                    <div className="Menu-overlay" onClick={() => setMobileMenuOpen(false)}></div>
                    <div className="Menu-items-container">
                      {/* This panel is hand-rolled rather than a `Menu`, so the nested menus
                          below cannot close it on their own. Publishing the close callback
                          makes activating any of their items dismiss the panel as well --
                          otherwise it stays open over the screen the item just navigated to
                          and the tap looks like it did nothing (App Store 2.1(a), 2026-07-31). */}
                      <MenuCloseContext.Provider value={closeMobileMenu}>
                        <div className="Menu-items mobile-menu-panel">
                          {!hideShipMenu && <MenuShip ship={ship} />}
                          {!hideShipMenu && <div className="Menu-item-divider"></div>}
                          <MenuAccount />
                          <div className="Menu-item-divider"></div>
                          <MenuHelp />
                        </div>
                      </MenuCloseContext.Provider>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {/* Desktop menus */}
          <div className="ShipView-menus-desktop">
            {[
              <div key="refresh" className="Menu">
                <button className="Menu-button" onClick={() => window.location.reload()}>
                  <Icon icon={Icons.Refresh} />
                </button>
              </div>,

              ...(!hideMenus ? [
                ...(!hideShipMenu ? [<MenuShip key="ship" ship={ship} />] : []),
                <MenuAccount key="account" />,
              ] : []),

              <MenuHelp key="help" />,
            ]}
          </div>
        </div>
      </div>
      <div className="ShipView-header-fill post"></div>
    </div>
  );
}
